import React from 'react';
import "./blog.css";
import { useLanguage } from '../../context/LanguageContext';

import Image2 from '../../assets/postBancoBV.jpg';
import Image3 from '../../assets/image.png';
import Image1 from '../../assets/Post - Gupy.png';

const Blog = () => {

  const { translations } = useLanguage();
  
  return (
    <section className="blog container section" id="blog">
      <h2 className="section__title">{translations.blogTitle}</h2>

      <div className="blog__container grid">
       <div className="blog__card">
          <div className="blog__thumb">
            <span className="blog__category">{translations.blogCategory3}</span>
            <a href="https://www.linkedin.com/feed/update/urn:li:share:7333648499042885632"><img src={Image3} alt="" 
            className="blog__img" /></a>
          </div>
          <div className="blog__details">
            <h3 className="blog__title">{translations.blogTheme3}</h3>
            <div className="blog__meta">
              <span>{translations.blogDate3}</span>
              <span className="blog__dot">.</span>
              <span>Glória</span>
            </div>
          </div>
        </div>

        <div className="blog__card">
          <div className="blog__thumb">
            <span className="blog__category">{translations.blogCategory1}</span>
            <a href="https://www.linkedin.com/posts/liviabraz_conectandoraaedzescomelas-estagiobv-activity-7311492974125727744-PjqX"><img src={Image2} alt="" 
            className="blog__img" /></a>
          </div>
          <div className="blog__details">
            <h3 className="blog__title">{translations.blogTheme1}</h3>
            <div className="blog__meta">
              <span>{translations.blogDate1}</span>
              <span className="blog__dot">.</span>
              <span>Glória</span>
            </div>
          </div>
        </div>

        <div className="blog__card">
          <div className="blog__thumb">
            <span className="blog__category">{translations.blogCategory2}</span>
            <a href="https://www.linkedin.com/posts/liviabraz_dicas-gupy-activity-7259882249691492352-vOAQ"><img src={Image1} alt="" 
            className="blog__img" /></a>
          </div>
          <div className="blog__details">
            <h3 className="blog__title">{translations.blogTheme2}</h3>
            <div className="blog__meta">
              <span>{translations.blogDate2}</span>
              <span className="blog__dot">.</span>
              <span>Glória</span>
            </div>
          </div>
        </div>

      </div>

    </section>
  )
}

export default Blog